<template>
  <div>
    <CardedSectionHeader
      icon="mdi-television"
      label="Promotion Preview"
      id="admin_pr0motion_featuring_edit_preview"
    ></CardedSectionHeader>
    <CardedDisplay>
      <PlainDisplay :show_icon="false">
        <PromotionHeader
          :is_loading="is_loading"
          :promotion="featured_promotion.promotion"
          :is_owner_view="is_owner"
          :is_in_admin_view="true"
        ></PromotionHeader>
        <div class="d-flex justify-space-between align-center pt-4 pb-4 grey lighten-5 pr-2 pl-2">
            <div>
                Platform: <b>{{featured_promotion.platform}}</b>
            </div>
            <div>Page: <b>{{featured_promotion.page}}</b></div>
            <div>Section: <b>{{featured_promotion.section}}</b></div>
        </div>
      </PlainDisplay>
    </CardedDisplay>
    <AdminPromotionsFeaturedAdd
        :is_loading="is_loading"
        :is_editing="true"
        :featured_promotion_editing="featured_promotion"
        :key="this_key_fp_key"
        ref="admin_featured_promotion_add_view_ref"
        @on-show-loader="$emit('on-show-loader')"
        @on-hide-loader="$emit('on-hide-loader')"
        @on-success-edit-featuring="on_success_edit_featuring"
    >
    </AdminPromotionsFeaturedAdd>
  </div>
</template>

<script>
import ServerClient from "../../../lib/ServerClient";
import Utils from "../../../lib/Utils";
import CardedSectionHeader from "./../../../components/CardedSectionHeader";
import CardedDisplay from "./../../../components/CardedDisplay";
import PlainDisplay from "./../../../components/PlainDisplay";
import PromotionHeader from "./../../../components/PromotionHeader";
import AdminPromotionsFeaturedAdd from "./AdminPromotionsFeaturedAdd"
export default {
  name: "AdminPromotionsFeaturedEdit",
  components: {
    CardedSectionHeader,
    CardedDisplay,
    PlainDisplay,
    PromotionHeader,
    AdminPromotionsFeaturedAdd
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    }
  },
  data: function () {
    return {
      featured_promotion_id: 0,
      featured_promotion: Utils.get_default_fetaured_promotion(),
      is_owner: false,
      _user: null,
      this_key_fp_key: "this_key_1",
      this_key_fp_key_truck: 1
    }
  },
  methods: {
    load_promotion() {
      this.$emit("on-show-loader");
      ServerClient.Promotions.get_featured_promotion(
        {
          id: this.featured_promotion_id,
          get_header_only: true,
        },
        (res) => {
          this.$emit("on-hide-loader");
          //console.log("This one ", res);
          var php_time_now = parseFloat(Utils.date_str_to_php_time(""));
          res.promotion.expiry = "";
          if (php_time_now < parseFloat(res.promotion.starts_on_timestamp)) {
            res.promotion.expiry = "pending";
          } else if (
            php_time_now >= parseFloat(res.promotion.starts_on_timestamp) &&
            php_time_now <= parseFloat(res.promotion.ends_on_timestamp)
          ) {
            res.promotion.expiry = "live";
          } else if (php_time_now > parseFloat(res.promotion.ends_on_timestamp)) {
            res.promotion.expiry = "expired";
          }

          this.featured_promotion = res;
          if (
            this._user &&
            this._user != null &&
            this.featured_promotion.promotion.business &&
            parseInt(this._user.id) == parseInt(this.featured_promotion.promotion.user_id)
          ) {
            this.is_owner = true;
          }
          this.this_key_fp_key_truck = this.this_key_fp_key_truck + 1;
          this.this_key_fp_key = "this_key_" + this.this_key_fp_key_truck;
          //this.$refs.admin_featured_promotion_add_view_ref.init_edit_form(this.featured_promotion);
        },
        (errors) => {
          this.$emit("on-hide-loader");
          console.log(
            "Errors while loading featured promotion for editing end view",
            errors
          );
        }
      );
    },
    on_success_edit_featuring(){
        this.load_promotion();
    }
  },
  mounted() {
    this.cmp_user = ServerClient.Login.get_logged_in_user();
    this.featured_promotion_id = parseInt(this.$route.params.id);
    //nyd
    //if the _user is not or they are not admins there  then just take this dude
    //to the loggin screen

    this.$emit("set-page-attributes", {
      title: "Edit Promotion's Featuring",
      crumps: [
        {
          text: "admin",
          disabled: false,
          href: "/admin",
        },
        {
          text: "Promotions",
          disabled: false,
          href: "/admin/promotions",
        },
        {
          text: "Feature",
          disabled: false,
          href: "/adin/promotions/featured",
        },
        {
          text: "Edit",
          disabled: true,
          href: "/adin/promotions/featured/edit/"+this.featured_promotion_id,
        },
      ],
      navbar_cols: 3,
    });

    this.load_promotion();
  },
};
</script>